// extracted by mini-css-extract-plugin
export default {"image":"o4-z","loaded":"p4-z"};